export default __webpack_public_path__ + "static/media/icon6.a2c4ee58.svg";